export const radioOptions = [
  {
    label: 'Μέγεθος Επιχείρησης',
    value: 'Μέγεθος Επιχείρησης',
  },
  {
    label: 'Είδος Δραστηριότητας',
    value: 'Είδος Δραστηριότητας',
  },
  {
    label: 'Υπέρβαση ορίου Kρατικών Eνισχύσεων ',
    value: 'Υπέρβαση ορίου Kρατικών Eνισχύσεων ',
  },
  {
    label: 'Μη Υποβολή Έγκυρων Εγγράφων',
    value: 'Μη Υποβολή Έγκυρων Εγγράφων',
  },
  {
    label: 'Άλλος Λόγος',
    value: 'Άλλος Λόγος',
  },
];
